const Icons = {
  video: 'https://backstage-img-ssl.a.88cdn.com/a58f24617216e42fd4e09a1b9c4e4e2634edf8b6',
  'application/vnd.rn-realmedia-vbr': 'https://backstage-img-ssl.a.88cdn.com/a58f24617216e42fd4e09a1b9c4e4e2634edf8b6',
  image: 'https://backstage-img-ssl.a.88cdn.com/de99fe8d4b6ffc2f64e533c5dc0ceed29b8c259a',
  text: 'https://static-movie.a.88cdn.com/668bd3d0132d4a1bae2dd1046d6265f0',
  audio: 'https://static-movie.a.88cdn.com/f492c9d5f9480f3725f4004046b467e3',
  dir: 'https://backstage-img-ssl.a.88cdn.com/019fc2a136a2881181e73fea74a4836efc02195d',
  other: 'https://static-movie.a.88cdn.com/1b27b2347dc22c42b61953d0895e14db',
  application: 'https://static-movie.a.88cdn.com/a67fe7bd81005d9d5071df95bc4044ca',
  'application/pdf': 'https://static-movie.a.88cdn.com/a56d79ba21f324379124d42f315a1af9',
  bt: 'https://backstage-img-ssl.a.88cdn.com/636aabac9eee211de3beb7cfe72eb25538a88e39',
  multiple: 'https://backstage-img-ssl.a.88cdn.com/2638eeb5b2534a64ea8d22771418e067a1b8a0c4',
}
export default Icons

export function getIconFromLink (link: string) {
  const isLink = /(thunder|magnet|http[s]?|ftp|ed2k):[\S]+/gi.test(link)
  if (!isLink) return Icons.other
  const isVideo = link.match(/\.(mp4|rmvb|m3u8|rm|mkv|avi|wmv|3gp|mov|flv|m4v)$/g)
  const isAudio = link.match(/\.(mp3|wav)$/g)
  const isImage = link.match(/\.(jpg|png|gif|jpeg|webp)$/g)
  if (isVideo) return Icons.video
  if (isAudio) return Icons.audio
  if (isImage) return Icons.image
  if (/(thunder|magnet|ftp|ed2k):[\S]+/gi.test(link)) {
    return Icons.bt
  }
  return Icons.other
}

export function getIconFromMineType (mineType: string) {
  const match = mineType?.match(/(video|audio|image|application\/pdf|application\/vnd.rn-realmedia-vbr|application|text)/)
  if (match) return Icons[match[0]]
  else return Icons.other
}
